<template>
  <div id="BusinessUnitPage" class="section">
    <div class="columns is-multiline has-text-left">
      <div class="column is-10-desktop is-12-tablet is-12-mobile">
        <h1 class="title">BUSINESS UNIT MANAGER</h1>
        <h1
          v-if="business_unit_list && business_unit_list.length > 0"
          class="subtitle is-6"
        >
          Total {{ business_unit_list.length }} rows founds
        </h1>
      </div>
      <div class="column is-2-desktop is-12-tablet is-12-mobile">
        <b-button
          expanded
          type="is-primary"
          icon-left="plus"
          @click.prevent="presentCreateBusinessUnitForm()"
        >
          Create New Unit
        </b-button>
      </div>
    </div>
    <div class="container">
      <div v-if="business_unit_list">
        <b-table striped :data="business_unit_list">
          <template slot-scope="props">
            <b-table-column field="business_unit_name" label="Name" sortable>
              {{ props.row.business_unit_name }}
            </b-table-column>

            <b-table-column field="business_unit_code" label="Code" sortable>
              {{ props.row.business_unit_code }}
            </b-table-column>

            <b-table-column field="managerList" label="Managers">
              <b-taglist>
                <b-tag
                  v-for="manager in props.row.managerList"
                  :key="manager._id"
                  type="is-warning"
                  >{{ manager.name }}</b-tag
                >
              </b-taglist>
            </b-table-column>

            <b-table-column field="action" label="Action" width="220">
              <div class="buttons">
                <b-button
                  outlined
                  size="is-small"
                  type="is-primary"
                  icon-right="lead-pencil"
                  @click="presentUpdateBusinessUnitForm(props.row)"
                />
                <b-button
                  outlined
                  size="is-small"
                  type="is-danger"
                  icon-right="delete"
                  @click="presentRemoveBUForm(props.row)"
                />
              </div>
            </b-table-column>
          </template>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon
                    size="is-large"
                    type="is-primary"
                    icon="emoticon-sad-outline"
                  />
                </p>
                <p>No any Business Unit here!.</p>
              </div>
            </section>
          </template>
        </b-table>
      </div>
      <div v-else>
        <section class="hero is-medium">
          <div class="hero-body">
            <div class="container">
              <h2 class="title is-4">Loading...</h2>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import BusinessUnitApi from "@/services/BusinessUnitApi";

import AlertManager from "@/utils/AlertManager";
import CreateBusinessUnitForm from "@/components/forms/CreateBusinessUnitForm.vue";

export default {
  name: "BusinessUnitPage",
  data() {
    return {
      business_unit_list: null
    };
  },
  methods: {
    presentCreateBusinessUnitForm: function() {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: CreateBusinessUnitForm,
        props: { mode: "create" },
        events: {
          create_success: () => {
            this.requestGetBusinessUnitList();
          }
        }
      });
    },
    presentUpdateBusinessUnitForm: function(bu_info) {
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: CreateBusinessUnitForm,
        props: { mode: "edit", selected_unit: bu_info },
        events: {
          update_success: () => {
            this.requestGetBusinessUnitList();
          }
        }
      });
    },
    presentRemoveBUForm: function(bu_info) {
      this.$buefy.dialog.prompt({
        title: "Confirm Remove Business Unit",
        message:
          "Are you sure you want to permanently remove <b>" +
          bu_info.business_unit_name +
          "</b> from the system?",
        inputAttrs: {
          type: "text",
          placeholder: "type " + bu_info.business_unit_name + " here..."
        },
        confirmText: "Remove",
        trapFocus: true,
        closeOnConfirm: false,
        onConfirm: (value, { close }) => {
          if (value === bu_info.business_unit_name) {
            this.requestRemoveBU(bu_info._id);
          } else {
            AlertManager.showErrorSnackbar(
              "Error: Input not match with business unit name"
            );
          }
          close();
        }
      });
    },
    requestGetBusinessUnitList: async function() {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await BusinessUnitApi.requestBusinessUnitList();
      loadingComponent.close();

      if (response.status) {
        this.business_unit_list = response.payload;
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    },
    requestRemoveBU: async function(bu_id) {
      const loadingComponent = this.$buefy.loading.open({
        container: null
      });
      const response = await BusinessUnitApi.requestRemoveBusinessUnit(bu_id);
      loadingComponent.close();
      if (response.status) {
        AlertManager.showSuccessSnackbar(response.message);
        this.requestGetBusinessUnitList();
      } else {
        AlertManager.showErrorSnackbar(response.message);
      }
    }
  },
  async beforeMount() {
    await this.requestGetBusinessUnitList();
  }
};
</script>
<style scoped></style>
